<template>
    <i class="fa fa-fax fa-lg"
        aria-hidden="false"
        :title="uLang('app.book_invoice')"
        @click="bookInvoice"
    ></i>
</template>

<script>
    import { ConfirmationAlert } from '~/Swals'

    export default {
        name: 'BookInvoiceButton',

        props: {
            invoiceId: {
                type: Number,
                required: false,
            },
            type: { /* The type of invoice: sales, buy, credit */
                type: String,
                required: true,
            }
        },

        computed: {
            invoiceType() {
                return 'app.' + this.type + '_invoice';
            }
        },

        methods: {
            bookInvoice() {
                new ConfirmationAlert({
                    text: this.uLang('app.confirm_book_invoice', { entity: this.uLang(this.invoiceType) }),
                }).show().then(async () => {
                    const {data} = await window.axios.post(route('invoices.' + this.type + '.book', { invoice: this.invoiceId }));

                    if (data.message === 'success') {
                        this.bookingSuccess(data)
                    } else if (data.booked) {
                        this.$snotify.error(data.message);
                        vue.$emit('reloadTable');
                    } else if (data.message === 'error') {
                        this.bookingError(data)
                    } else {
                        this.$snotify.error(data.message);
                    }
                })
            },

            bookingSuccess(data) {
                this.$snotify.info(uLang('app.successfully_booked_invoice', {entity: this.uLang(this.invoiceType)}));
                vue.$emit('reloadTable');
            },

            bookingError(data) {
                this.$snotify.error(uLang('app.error_booked_invoice', { entity: this.lang(this.invoiceType) }));
            },
        },
    }
</script>

<style>

</style>